//@ts-nocheck

import React from "react";

import * as S from './InfoWindow.styles'

import { Heading, Paragraph } from "../../../atoms/Typography/Typography.component";
import { SpacerBase } from "../../../atoms/GridSystem";
import ItemsGrouped from "../../../molecules/ItemsGrouped/ItemsGrouped.component";
import Button from "../../../atoms/Button/Button.component";
import { useTranslations } from "next-intl";

const InfoWindow = ({
  title,
  description,
  actions,
  metadata,
  address,
  markerType
}) => {
  const t = useTranslations()
  
  return (
    <S.InfoWindow>
      <S.InfoWindowTags>

      </S.InfoWindowTags>
      <S.InfoWindowContent>
        { title ? (
          <>
            <Heading content={title} weight={'medium'} typo={'headingSM'} />
            <SpacerBase xs={1} />
          </>
        ) : null }
        { description ? (
          <>
            <Paragraph content={description} typo={'paragraphMD'} />
            <SpacerBase xs={1} />
          </>
        ) : null }
        { address ? (
          <>
            <Paragraph content={address} typo={'paragraphMD'} />
            <SpacerBase xs={1} />
          </>
        ) : null }
        { metadata?.phone ? (
          <>
            <Paragraph content={metadata?.phone} typo={'paragraphMD'} />
            <SpacerBase xs={1} />
          </>
        ) : null }
        { metadata.website || metadata.email ? (
          <ItemsGrouped space={8} direction={'row'} justify={'flex-start'} isWrap>
            { metadata?.website ? <Paragraph content={metadata?.website} typo={'paragraphMD'} /> : null }
            { metadata?.website && metadata?.email ? <Paragraph content={'|'} typo={'paragraphMD'} /> : null }
            { metadata?.email ? <Paragraph content={metadata?.email} typo={'paragraphMD'} /> : null }
          </ItemsGrouped>
        ) : null }
      </S.InfoWindowContent>
      { actions.length > 0 ? (
        <S.InfoWindowActions>
          { actions.map((action) => {
            
            if (action.type === "navigate") {
              return (
              <Button 
                key={action.id} 
                href={action.url} 
                label={t('storeLocator.actionNavigateLabel')}
                variant={'primary'}
                fullWidth
              />
            )
          }
        })}
        </S.InfoWindowActions>
      ) : null }
    </S.InfoWindow>
  )
}

export default InfoWindow